import React from "react";

/// props validation | SQ(javascript:S6774)
BenchmarkCreateAnalysisWelcome.propTypes = {};
///
export default function BenchmarkCreateAnalysisWelcome(props) {
  return <div className="page-content-center">Create Benchmark Analysis</div>;
}
